// export layout related constants
export const LAYOUT_VERTICAL = 'vertical';

export const LAYOUT_VERTICAL_SETTINGS = 'settings';
